import { useContext, useMemo } from 'react';
import { useAuthContext } from 'shared/contexts/AuthContext';
import SettingsContext from '../contexts/SettingsContext';
import useRoutes, { LayoutsE } from '../routes';
import { RoleE } from 'shared/api/types/auth';

// No access array -> All view
// [] -> Only admin
// [RoleE.MANAGER] -> Only manager and admin

const useGetAllRoutes = (isShowInNav?: boolean) => {
  const { isDevMode } = useContext(SettingsContext);
  const { self } = useAuthContext();
  const routes = useRoutes();

  const dashboardRoutes = routes[LayoutsE.DASHBOARD];

  return useMemo(() => {
    const newGroups = dashboardRoutes.groups.map((group) => {
      // Filter routes in this group
      const filteredRoutes = group.routes
        .map(route => ({
          ...route,
          layout: LayoutsE.DASHBOARD as LayoutsE,
          isProtected: dashboardRoutes.isProtected,
          isHideInAuth: dashboardRoutes.isHideInAuth,
        }))
        .filter(route =>
          route.isProtected === !!self &&
          route.isHideInAuth === !self
          // && (isDevMode ? true : !route.isDisabled)
        )
        .filter(({ access }) => {
          if (!access) return true;
          if (!access.length && self.role === RoleE.ADMIN) return true;
          return access.includes(self.role);
        })
        .filter(route => (isShowInNav ? route.isShowInNav : true));

      return {
        group: group.group,
        icon: group.icon,
        routes: filteredRoutes,
      };
    });

    return newGroups;
  }, [isDevMode, self, routes, isShowInNav]);
};

export default useGetAllRoutes;
